import type { TenantConfig } from '@/types/TenantConfig'

const blue = '#0A279C'

export const agnsw: TenantConfig = {
  logo: 'assets/agnsw/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBackground: '#0a279c',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
    mobileFooter: {
      cartButtonBorder: '2px solid #0a279c',
      cartButtonIconColor: '#0a279c',
      textColor: 'var(--dark-gray)',
      priceTextColor: 'var(--dark-gray)',
    },
  },
  teaserImageSize: {
    width: 360,
    height: 273,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/agnsw/static/completed-2.jpg',
        mobile: 'assets/agnsw/static/completed-mobile.jpg',
      },
      completedContentOffset: {
        desktop: '-155px',
        mobile: '-140px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: '/assets/agnsw/static/fonts.css',
    },
  },
  i18nOverrides: {
    en: {
      completedOrdersRoute: {
        ticketsOrderNumber: 'Your Booking Reference is {number}',
      },
    },
  },
}
